import './LinkedinAuth.scss';

import { FC, useContext, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { AppContext } from 'components/AppContext/AppContext';
import { ConnectionStatus } from 'models/ConnectionStatus';
import { LogLevel } from 'models/LogLevel';
import { SocialAccount, SocialConnectionType } from 'models/Social/SocialAccount';
import moment from 'moment';
import { Button } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';

interface LinkedinAuthProps {
  onTokenAcquired: (response: SocialAccount) => Promise<void>;
}

interface LinkedinAuthParameters {
  connectionType: SocialConnectionType;
  token: string;
  expires: string;
  userId: string;
  screenName: string;
  photo: string;
}

const LinkedinAuth: FC<LinkedinAuthProps> = ({ onTokenAcquired }) => {
  const { user } = useAuth0();
  const { configRepo, selectedProjectId, sendLog } = useContext(AppContext);
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const qp: LinkedinAuthParameters | undefined = Object.fromEntries(
    params,
  ) as any as LinkedinAuthParameters;

  useEffect(() => {
    if (qp?.token && qp?.expires && qp.connectionType === SocialConnectionType.Linkedin) {
      const expiresIn = moment(qp!.expires).toDate();
      const socialAccount: SocialAccount = {
        projectId: selectedProjectId!,
        blabberJaxUserId: user!.sub!,
        socialAccountName: qp.screenName,
        connectionType: SocialConnectionType.Linkedin,
        socialAccountUserId: qp!.userId,
        token: qp!.token,
        tokenExpiresIn: expiresIn,
        connectionStatus: ConnectionStatus.OK,
        socialProfilePhotoUrl: qp.photo,
      };

      const fetchData = async () => {
        await onTokenAcquired(socialAccount);
        navigate(window.location.pathname, {
          replace: true,
        });
      };
      fetchData().catch((e) => {
        sendLog(e.message, LogLevel.error, e);
      });
    }
  }, []);

  // AuthorizeAsync
  const handleClick = async () => {
    const url = `${configRepo!.PUBLISH_API_BASE_URI
      }/api/LinkedInAuth?projectId=${selectedProjectId}&userId=${encodeURI(user!.sub!)}`;

    window.location.href = url;
  };

  if (!selectedProjectId) {
    return <span style={{ fontStyle: 'italic' }}>Loading...</span>;
  }
  return (
    <Button
      variant="primary"
      onClick={handleClick}
      style={{ backgroundColor: '#0a66c2', borderRadius: 0 }}
    >
      <i className="bi bi-linkedin" /> Login with LinkedIn
    </Button>
  );
};

export default LinkedinAuth;
